import {
  AccountApiClient,
  AgentApiClient,
  ApiError,
  PartnerApiClient,
  ProfileApiClient,
  ProgramApiClient,
  PublicApiClient,
  ReferralApiClient
} from "@humanex/ui/libs";

import { AppCfg } from "@/configs/app";

import { firebaseService } from "./firebase";

export { ApiError } from "@humanex/ui/libs";
export type { AgentStats, AgentTree, ApplicationRewardWithDetail, ManagedCandidate } from "@humanex/ui/libs";

const defaultConfig = {
  baseURL: AppCfg.apiBaseUrl,
  getToken: async () => {
    const curUser = firebaseService.currentUser;
    if (!curUser) {
      throw new ApiError("Authentication required but no valid user found", 401);
    }
    const token = await curUser.getIdToken();
    if (!token) {
      throw new ApiError("Authentication required but no valid token found", 401);
    }
    return token;
  }
};

export const profileApiClient = new ProfileApiClient(defaultConfig);
export const agentApiClient = new AgentApiClient(defaultConfig);
export const accountApiClient = new AccountApiClient(defaultConfig);
export const referralApiClient = new ReferralApiClient(defaultConfig);

export const programApiClient = new ProgramApiClient(defaultConfig);
export const partnerApiClient = new PartnerApiClient(defaultConfig);
export const publicApiClient = new PublicApiClient({ ...defaultConfig });
